var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeContent === "select-credit"
        ? _c(
            "b-row",
            {
              staticStyle: { "margin-bottom": "40px", "text-align": "center" },
              attrs: { "align-h": "center" }
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c("h2", { staticClass: "font-weight-bold mb-5" }, [
                    _vm._v("Select Credit Amount")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { staticStyle: { "margin-bottom": "56px" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-100 d-flex justify-content-between mb-4"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column text-right align-items-end"
                            },
                            [
                              _c("b-form-select", {
                                staticClass: "mb-0",
                                staticStyle: { width: "150px" },
                                attrs: { options: _vm.list },
                                model: {
                                  value: _vm.selectedCredit,
                                  callback: function($$v) {
                                    _vm.selectedCredit = $$v
                                  },
                                  expression: "selectedCredit"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column text-left" },
                            [
                              _c("span", [_vm._v(_vm._s(_vm.priceDollar))]),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(_vm.approxText))
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-form-group", [
                    _c(
                      "h5",
                      { staticClass: "font-weight-bold mb-5 text-left" },
                      [_vm._v("Who are you buying this for")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "w-100 d-flex justify-content-between mb-4"
                      },
                      [
                        _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.buyForSelf,
                                expression: "buyForSelf"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              id: "for-self",
                              name: "buyForSelf"
                            },
                            domProps: {
                              value: true,
                              checked: _vm._q(_vm.buyForSelf, true)
                            },
                            on: {
                              change: function($event) {
                                _vm.buyForSelf = true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label ml-4",
                              attrs: { for: "for-self" }
                            },
                            [
                              _c("h4", { staticClass: "d-flex text-left" }, [
                                _vm._v("Myself")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-muted text-left" }, [
                                _vm._v(
                                  "\n                Buying for yourself will automatically add the balance to your account\n              "
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "w-100 d-flex justify-content-between mb-4"
                      },
                      [
                        _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.buyForSelf,
                                expression: "buyForSelf"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              id: "for-other",
                              name: "buyForSelf"
                            },
                            domProps: {
                              value: false,
                              checked: _vm._q(_vm.buyForSelf, false)
                            },
                            on: {
                              change: function($event) {
                                _vm.buyForSelf = false
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label ml-4",
                              attrs: { for: "for-other" }
                            },
                            [
                              _c("h4", { staticClass: "d-flex text-left" }, [
                                _vm._v("For Someone Else")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-muted text-left" }, [
                                _vm._v(
                                  "\n                Buying for someone else will generate redemption code that they can redeem within the app\n              "
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block",
                      on: { click: _vm.goToPaymentMethod }
                    },
                    [_vm._v("Go to payment method")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-left mb-4" }, [
                    _c("small", { staticClass: "text-left" }, [
                      _vm._v("*All prices exclusive of Stripe fees")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "w-100" }),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-center",
                  attrs: { cols: "12", md: "4" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn-back d-flex rounded-circle cursor-pointer",
                      on: { click: _vm.back }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon-back",
                        attrs: { icon: ["fas", "chevron-left"] }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeContent === "select-payment"
        ? _c(
            "b-row",
            {
              staticStyle: { "margin-bottom": "40px", "text-align": "center" },
              attrs: { "align-h": "center" }
            },
            [
              _c("b-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "payment-container" }, [
                  _c("h4", { staticClass: "font-weight-bold mb-4" }, [
                    _vm._v("Select Payment")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c(
                        "span",
                        { staticClass: "small-muted-text text-left" },
                        [_vm._v("CARD")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column",
                          staticStyle: { "margin-bottom": "68px" }
                        },
                        [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("div", { staticClass: "input-radio-payment" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.paymentMethod,
                                    expression: "paymentMethod"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "payment_method",
                                  value: "credit_card"
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.paymentMethod,
                                    "credit_card"
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.paymentMethod = "credit_card"
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "payment-method-label w-100 text-left"
                              },
                              [
                                _vm._v(
                                  "\n                  Credit Card / Debit Card\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "payment-method-images d-flex justify-content-end"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/visa.png"),
                                    alt: "logo"
                                  }
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/master.png"),
                                    alt: "logo"
                                  }
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/american-express.png"),
                                    alt: "logo"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c(
                        "span",
                        { staticClass: "small-muted-text text-left" },
                        [_vm._v("WALLET")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column",
                          staticStyle: { "margin-bottom": "40px" }
                        },
                        [
                          false
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex payment-item justify-content-between"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-radio-payment" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.paymentMethod,
                                            expression: "paymentMethod"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "payment_method",
                                          value: "grab_pay",
                                          disabled: ""
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.paymentMethod,
                                            "grab_pay"
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.paymentMethod = "grab_pay"
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "payment-method-label text-left w-100"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  GrabPay\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "payment-method-images d-flex justify-content-end"
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/grabpay.png"),
                                          alt: "logo"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          false
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex payment-item justify-content-between"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-radio-payment" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.paymentMethod,
                                            expression: "paymentMethod"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "payment_method",
                                          value: "gcash",
                                          disabled: ""
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.paymentMethod,
                                            "gcash"
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.paymentMethod = "gcash"
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "payment-method-label text-left w-100"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  GCash\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "payment-method-images d-flex justify-content-end"
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/gcash.png"),
                                          alt: "logo"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex payment-item justify-content-between"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-radio-payment" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.paymentMethod,
                                        expression: "paymentMethod"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      name: "payment_method",
                                      value: "wechat"
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.paymentMethod,
                                        "wechat"
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.paymentMethod = "wechat"
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "payment-method-label text-left w-100"
                                },
                                [
                                  _vm._v(
                                    "\n                  WeChat Pay\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "payment-method-images d-flex justify-content-end"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/wechat.png"),
                                      alt: "logo"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block mb-3 mt-5",
                      on: { click: _vm.pay }
                    },
                    [_vm._v("Go to payment")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-center d-flex flex-column align-items-start"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            "margin-bottom": "-3px"
                          }
                        },
                        [_vm._v("*All prices exclusive of service fee")]
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w-100" }),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-center mt-5",
                  attrs: { cols: "12", md: "4" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn-back d-flex rounded-circle cursor-pointer",
                      on: { click: _vm.backPayment }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon-back",
                        attrs: { icon: ["fas", "chevron-left"] }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4932a906", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4932a906","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TopUp.vue
// module id = null
// module chunks = 